import React, {Component} from 'react';
import {inject} from 'mobx-react'
import moment from 'moment';

import Question from './Question'
import Result from './Result'
import ShareBlock from './ShareBlock'
import structure from '../structure'

import {
    LOCAL_STORAGE_NEWSLETTER_LAST_ASKED,
    LOCAL_STORAGE_NEWSLETTER_SIGNED_UP,
    MODAL_NEWS_LETTER,
    MODAL_SHARE_CALCULATION
} from "../store/const";

@inject("store")
export default class QuestionList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            questions: [],
            result: false,
            resultText: "",
            resultDate: false,
            date: '',
            resultDate2: undefined,
            date2: undefined,
            ignoreHolidays: false,
        };
    }

    componentDidMount() {
        const data = structure;

        const rootQuestion = {
            id: data.id,
            question: data.question,
            info: data.info,
            resultInfo: data.resultInfo,
            answers: data.answers,
            type: data.type
        };

        // only show dialog if it is more thatn 14 days since it was last shown and user havent signed up yet
        let shouldShowNewsLetterModal = false;
        if (typeof(Storage) !== "undefined") {

            const isSignedUpForNewsLetter = localStorage.getItem(LOCAL_STORAGE_NEWSLETTER_SIGNED_UP);
            const lastAsked = localStorage.getItem(LOCAL_STORAGE_NEWSLETTER_LAST_ASKED);

            const lastAskedDate = lastAsked !== null ? moment(parseInt(lastAsked)) : null;
            const date14DaysAgo = moment().subtract(14, 'days');
            // const date14DaysAgo = moment().subtract(30, 'seconds'); // for testing

            // if lastAskedDate is null then it is first time and modal should be shown
            if (lastAskedDate == null) {
                shouldShowNewsLetterModal = true
            } else {
                shouldShowNewsLetterModal = !isSignedUpForNewsLetter && lastAskedDate < date14DaysAgo
            }
        }

        // handle
        const questions = [rootQuestion];

        let lastQuestion = rootQuestion;

        if (app && editAnswers) {
            for (var i = 0; i < editAnswers.length; i++) {
                var answerId = editAnswers[i];
                //Find element with id
                for (var j = 0; j < lastQuestion.answers.length; j++) {
                    var answer = lastQuestion.answers[j];
                    if (answer.id == answerId) {
                        var newQuestion = {
                            id: answer.id,
                            question: answer.question,
                            type: answer.type,
                            answers: answer.answers,
                            info: answer.info,
                            resultInfo: answer.resultInfo,
                            ignoreHolidays: answer.ignoreHolidays,
                            answer: answer.text
                        };
                        if (answer.type === "date") {
                            newQuestion.days = answer.days;
                            newQuestion.result = answer.result;
                            newQuestion.resultDate = answer.resultDate;
                            newQuestion.resultDate2 = answer.resultDate2;
                        }

                        if (answer.type === 'result') {
                            newQuestion.days = 0;
                            newQuestion.result = answer.result;
                            newQuestion.resultDate = '';
                            newQuestion.resultDate2 = '';
                        }

                        questions.push(newQuestion);
                        lastQuestion = newQuestion;
                        break;
                    }
                }
            }

            this.props.store.handleResult({
                questions,
                ignoreHolidays: editIgnoreHolidays,
                resultInfo: editResultInfo,
                resultDate: editResultDate,
                date: editDate,
                printDate: editPrintDate,
                resultDate2: editResultDate2,
                date2: editDate2
            });

            var state = {
                result: true,
                resultInfo: editResultInfo,
                resultDate: editResultDate,
                date: editDate,
                ignoreHolidays: editIgnoreHolidays,
                printDate: editPrintDate
            };

            if (editResultDate2) {
                state.resultDate2 = editResultDate2;
            }
            if (editResultDate2) {
                state.date2 = editDate2;
            }
            this.setState(state);
        }

        this.setState({data: data, questions: questions, shouldShowNewsLetterModal: shouldShowNewsLetterModal});
    }

    handleSave = () => {
        var answers = [];
        var questionCount = this.state.questions.length;
        var type = '';
        for (var i = 0; i < questionCount; i++) {
            var q = this.state.questions[i];
            answers.push(q.id);
            if (i === 1) {
                var types = this.state.questions[0].answers;
                for (var j = 0; j < types.length; j++) {
                    if (types[j].id == q.id) {
                        type = types[j].text;
                        break;
                    }
                }
            }
        }
        var res = this.state.resultInfo;
        var resDate = this.state.resultDate;
        var resDate2 = this.state.resultDate2;
        var d = this.state.date;
        var d2 = this.state.date2;
        var data = {
            "resultInfo": res,
            "date": d,
            "resultDate": resDate,
            "date2": d2,
            "resultDate2": resDate2,
            "ignoreHolidays": this.state.ignoreHolidays,
            "printDate": this.state.printDate,
            "type": type
        };
        var url = 'app://' + jQuery.param(data);
        var formattedAnswers = JSON.stringify(answers);
        // var formattedAnswers = formattedAnswers.replace(/"/g, '');
        url = url + '&answers=' + encodeURIComponent(formattedAnswers);
        sendObjectMessage(url);
    };

    handleShare = () => {
        if (this.state.result) {
            this.props.store.showModal(MODAL_SHARE_CALCULATION);
        }
    };

    componentWillUpdate(nextProps, nextState) {
        const questionCount = nextState.questions.length;
        const activeQuestion = nextState.questions[questionCount - 1];
        const res = nextState.result !== false;

        const info = res ? activeQuestion.resultInfo : activeQuestion.info;

        const data = {
            question: activeQuestion.question,
            questionCount: questionCount,
            info: info,
            hasResult: res
        };

        this.props.store.addAssignment(data);
    }

    handleAnswer = (answer) => {

        // when an answer it clicked the next question is added

        const newQuestion = {
            id: answer.id,
            question: answer.question,
            type: answer.type,
            answers: answer.answers,
            info: answer.info,
            resultInfo: answer.resultInfo,
            ignoreHolidays: answer.ignoreHolidays,
            answer: answer.text
        };

        if (answer.type === 'date') {
            newQuestion.days = answer.days;
            newQuestion.result = answer.result;
            newQuestion.resultDate = answer.resultDate;
            newQuestion.resultDate2 = answer.resultDate2;
        }

        if (answer.type === 'result') {
            newQuestion.days = 0;
            newQuestion.result = answer.result;
            newQuestion.resultDate = '';
            newQuestion.resultDate2 = '';
        }

        const questions = this.state.questions;
        questions.push(newQuestion);

        this.setState({
            questions: questions,
        });
        this.props.collapse();
    };

    handleInfoClick = (index) => {
        const questions = this.state.questions.slice(0, index + 1);

        this.setState({questions: questions, result: false});
        this.props.collapse();
    };

    handleResult = (ignoreHolidays, resultInfo, resultDate, date, printDate, resultDate2, date2) => {

        if (this.state.shouldShowNewsLetterModal) {
            this.props.store.showModal(MODAL_NEWS_LETTER);
            localStorage.setItem(LOCAL_STORAGE_NEWSLETTER_LAST_ASKED, moment().toDate().getTime());
        }

        this.props.store.handleResult({
            questions: this.state.questions,
            ignoreHolidays,
            resultInfo,
            resultDate,
            date,
            printDate,
            resultDate2,
            date2
        });

        this.setState({
            result: true,
            resultInfo: resultInfo,
            resultDate: resultDate,
            date: date,
            resultDate2: resultDate2,
            date2: date2,
            ignoreHolidays: ignoreHolidays,
            printDate: printDate,
            shouldShowNewsLetterModal: false
        });
    };

    handleReset = () => {
        var questions = this.state.questions;
        questions = questions.slice(0, 1);

        // scroll to top
        if ($('html').scrollTop()) {
            $('html').animate({scrollTop: 0}, 'slow');
        } else {
            $('body').animate({scrollTop: 0}, 'slow');
        }

        this.setState({
            questions: questions,
            result: false,
        });
        this.props.collapse();
    };

    handlePrint = () => {
        window.print();
    };

    render() {
        const {
            questions,
            result,
            printDate,
            resultInfo,
            resultDate,
            date,
            date2,
            resultDate2,
            ignoreHolidays
        } = this.state;
        const questionsLength = questions.length;
        let isLastQuestion = false;

        return (
            <div>
                <ul className="questionList">
                    {
                        questions.map((question, index) => {

                            isLastQuestion = questionsLength === index + 1; // used to check if answers should be visible

                            let nextQuestion;
                            if (!isLastQuestion) {
                                nextQuestion = questions[index + 1];
                            } else {
                                if (result) {
                                    nextQuestion = {answer: printDate}
                                } else {
                                    nextQuestion = {answer: undefined};
                                }
                            }

                            return <Question
                                key={question.id}
                                question={question}
                                index={index + 1}
                                onAnswerClick={this.handleAnswer}
                                onInfoClick={this.handleInfoClick}
                                resultHandler={this.handleResult}
                                isLastQuestion={isLastQuestion}
                                result={result}
                                ignoreHolidays={question.ignoreHolidays}
                                answerText={nextQuestion.answer}
                            />
                        })
                    }
                </ul>

                {result &&
                <Result result={resultInfo}
                        resultDate={resultDate}
                        date={date}
                        date2={date2}
                        resultDate2={resultDate2}
                        ignoreHolidays={ignoreHolidays}/>
                }

                {result &&
                <ShareBlock
                    resetHandle={this.handleReset}
                    shareHandle={this.handleShare}
                    printHandle={this.handlePrint}
                    saveHandle={this.handleSave}/>
                }
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/QuestionList.js